module.exports = {"433123101":"廖家桥镇","433123104":"茶田镇","433123105":"吉信镇","433123107":"腊尔山镇","433123108":"禾库镇","433123109":"沱江镇","433123110":"阿拉营镇","433123111":"木江坪镇","433123112":"山江镇","433123113":"落潮井镇","433123114":"新场镇","433123115":"筸子坪镇","433123116":"千工坪镇","433123204":"水打田乡","433123205":"林峰乡","433123216":"麻冲乡","433123220":"两林乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/433123.json
// module id = 2063
// module chunks = 0